/* OAKSANTUM – skrypty motywu. Bez zewnętrznych bibliotek.
   Każda funkcja jest opcjonalna: strona działa także, gdy skrypt się nie wczyta. */
(function () {
  'use strict';

  var OAK = window.OAK || {};
  var S = OAK.strings || {};
  var locale = OAK.locale || document.documentElement.lang || 'pl';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* ---------------- formatowanie cen ---------------- */
  function formatMoney(cents, format) {
    format = format || OAK.moneyFormat || '{{amount}}';
    var value = Number(cents) || 0;
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var out;
    switch (key) {
      case 'amount_no_decimals': out = withDelimiters(value, 0); break;
      case 'amount_with_comma_separator': out = withDelimiters(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = withDelimiters(value, 0, '.', ','); break;
      case 'amount_with_space_separator': out = withDelimiters(value, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = withDelimiters(value, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': out = withDelimiters(value, 2, "'", '.'); break;
      case 'amount_with_period_and_space_separator': out = withDelimiters(value, 2, ' ', '.'); break;
      default: out = withDelimiters(value, 2);
    }
    // jak filtr money_without_trailing_zeros: 350,00 → 350
    if (value % 100 === 0) out = out.replace(/[.,]00$/, '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]*>/g, '');
  }

  /* ---------------- ilość (+ / −) ---------------- */
  function initQty(root) {
    $$('[data-qty]', root).forEach(function (box) {
      var input = $('input', box);
      if (!input) return;
      function set(v) {
        var min = parseInt(input.min || '0', 10);
        var max = parseInt(input.max || '99', 10);
        v = Math.max(min, Math.min(max, v));
        if (String(v) !== input.value) {
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      var minus = $('[data-qty-minus]', box);
      var plus = $('[data-qty-plus]', box);
      if (minus) minus.addEventListener('click', function () { set((parseInt(input.value, 10) || 0) - 1); });
      if (plus) plus.addEventListener('click', function () { set((parseInt(input.value, 10) || 0) + 1); });
    });
  }

  /* ---------------- zakup ---------------- */
  function initBuyForms() {
    $$('[data-buy-form]').forEach(function (form) {
      var box = form.closest('[data-buybox]') || document;
      var totalEl = $('[data-buy-total]', box);
      var imageEl = $('[data-buy-image]', box);
      var qtyInput = $('input[name="quantity"]', form);
      var button = $('[data-buy-button]', form);
      var errorEl = $('[data-buy-error]', form);
      var buttonHtml = button ? button.innerHTML : '';
      if (button) button.dataset.label = buttonHtml;

      function selected() { return $('input[name="id"]:checked', form); }

      function update() {
        var radio = selected();
        if (!radio) return;
        var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        if (totalEl) totalEl.textContent = formatMoney(Number(radio.dataset.price) * qty);
        if (imageEl && radio.dataset.image && imageEl.getAttribute('src') !== radio.dataset.image) {
          imageEl.src = radio.dataset.image;
          if (radio.dataset.srcset) imageEl.srcset = radio.dataset.srcset;
        }
      }

      form.addEventListener('change', update);
      form.addEventListener('input', function (e) { if (e.target === qtyInput) update(); });
      update();

      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) return; // zwykłe wysłanie formularza
        e.preventDefault();
        var radio = selected();
        if (!radio) return;
        if (qtyInput && (!qtyInput.value || parseInt(qtyInput.value, 10) < 1)) qtyInput.value = 1;
        if (errorEl) errorEl.hidden = true;
        if (button) { button.disabled = true; button.textContent = S.productAdding || '…'; }

        var data = new FormData(form);
        data.delete('return_to');
        fetch((OAK.routes && OAK.routes.cartAdd ? OAK.routes.cartAdd : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: data
        }).then(function (res) {
          return res.json().then(function (json) { return { ok: res.ok, json: json }; });
        }).then(function (r) {
          if (!r.ok) throw r.json;
          try {
            if (window.fbq) {
              var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
              window.fbq('track', 'AddToCart', {
                value: (Number(radio.dataset.price) * qty) / 100,
                currency: OAK.currency,
                content_ids: [radio.value],
                content_type: 'product'
              });
            }
          } catch (err) { /* nic */ }
          window.location.href = (OAK.routes && OAK.routes.checkout) || '/checkout';
        }).catch(function (err) {
          if (button) { button.disabled = false; button.innerHTML = buttonHtml; }
          if (errorEl) {
            var msg = (err && (err.description || err.message)) ? String(err.description || err.message) : '';
            errorEl.textContent = (S.productError || '') + (msg && err.status ? ' (' + msg + ')' : '');
            errorEl.hidden = false;
          }
          if (!err || !err.status) {
            // błąd sieci lub nieznany – spróbuj zwykłego wysłania formularza
            if (err instanceof TypeError) form.submit();
          }
        });
      });
    });
  }

  /* ---------------- koszyk ---------------- */
  function initCart() {
    var form = $('[data-cart-form]');
    if (!form) return;
    var updateBtn = $('[data-cart-update]', form);
    var timer;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (form.requestSubmit && updateBtn) form.requestSubmit(updateBtn);
        else if (updateBtn) updateBtn.click();
      }, 700);
    });
  }

  function refreshCartCount() {
    if (!window.fetch) return;
    fetch(((OAK.routes && OAK.routes.cart) || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      }).catch(function () {});
  }

  /* ---------------- opinie ---------------- */
  var reviewsState = { all: [], shown: 0, pageSize: 6 };

  function plural(n) {
    var cat = 'other';
    try { cat = new Intl.PluralRules(locale).select(n); } catch (e) { cat = n === 1 ? 'one' : 'other'; }
    if (cat === 'one') return S.reviewsOne;
    if (cat === 'few') return S.reviewsFew;
    if (cat === 'many') return S.reviewsMany;
    return S.reviewsOther || S.reviewsMany;
  }
  function fmtNumber(n, digits) {
    try { return Number(n).toLocaleString(locale, { minimumFractionDigits: digits, maximumFractionDigits: digits }); }
    catch (e) { return Number(n).toFixed(digits); }
  }
  function fmtDate(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return '';
    try { return d.toLocaleDateString(locale, { day: 'numeric', month: 'long', year: 'numeric' }); }
    catch (e) { return d.toDateString(); }
  }
  function esc(text) {
    var div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }
  var starSvg = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.4l-5.9 3.1 1.2-6.5L2.5 9.4l6.6-.9z"/></svg>';
  var thumbSvg = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 10v11H3V10zM7 10l4-8a3 3 0 0 1 3 3v4h5.5a2 2 0 0 1 2 2.3l-1.4 8A2 2 0 0 1 18 21H7"/></svg>';
  var translateSvg = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5h9M8.5 3v2M11 5c-1 4-3.5 7-7 9M6 9c1.4 2.3 3.4 4 6 5M13 21l4-9 4 9M14.5 18h5"/></svg>';

  function starsHtml(rating) {
    var r = Math.round(Number(rating) || 0);
    var html = '<span class="stars" role="img" aria-label="' + r + '/5">';
    for (var i = 1; i <= 5; i++) html += '<span style="' + (i > r ? 'color:#c9cbc2' : '') + '">' + starSvg + '</span>';
    return html + '</span>';
  }

  /* --- język opinii i automatyczne tłumaczenie --- */
  function normText(t) { return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function detectLang(t) {
    var s = ' ' + String(t || '').toLowerCase() + ' ';
    if (/[ąćęłńśźż]/.test(s) || /\s(się|jest|nie|mi|na|że|polecam|bardzo|czuje|jak|po|dla|przy|tez|też|juz|już)\s/.test(s)) return 'pl';
    if (/[äöüß]/.test(s) || /\s(ich|und|ist|die|der|das|nicht|sehr|mein|meine|wir|es|mit)\s/.test(s)) return 'de';
    if (/\s(the|and|is|my|it|i|very|with|was|this|for|feel)\s/.test(s)) return 'en';
    if (/[čřžěůý]/.test(s)) return 'cs';
    return 'unknown';
  }
  function needsTranslation(t) {
    var l = detectLang(t);
    if (l === OAK.lang) return false;
    if (l === 'unknown') return OAK.lang !== 'pl';
    return true;
  }
  var trQueue = Promise.resolve();
  function translateText(text) {
    var cfg = OAK.reviews || {};
    var key = 'oak-tr:' + OAK.lang + ':' + normText(text).slice(0, 160);
    try { var hit = sessionStorage.getItem(key); if (hit) return Promise.resolve(hit); } catch (e) {}
    if (!cfg.translateApi || !window.fetch) return Promise.reject(new Error('no api'));
    // jedno tłumaczenie naraz – nie przeciążamy serwera
    var job = trQueue.then(function () {
      return fetch(cfg.translateApi, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ text: text, target_lang: String(OAK.lang || 'en').toUpperCase(), path: window.location.pathname, host: window.location.hostname })
      }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (data) {
        var out = data && data.translations && data.translations[0] && data.translations[0].text;
        if (!out) throw new Error('empty');
        try { sessionStorage.setItem(key, out); } catch (e) {}
        return out;
      });
    });
    trQueue = job.catch(function () {});
    return job;
  }
  function applyTranslation(el, original, t) {
    el.dataset.original = original;
    el.dataset.translated = t;
    el.textContent = t;
    var note = document.createElement('span');
    note.className = 'translated-note';
    note.innerHTML = esc(S.translated || '') + ' · <button type="button" data-show-original>' + esc(S.showOriginal || '') + '</button>';
    el.insertAdjacentElement('afterend', note);
    var card = el.closest('[data-review-id]');
    var btn = card && $('[data-translate]', card);
    if (btn) btn.hidden = true;
  }
  function translateReview(el) {
    var original = el.dataset.original || el.textContent.trim();
    return translateText(original).then(function (t) {
      if (normText(t) === normText(original)) return false;
      applyTranslation(el, original, t);
      return true;
    });
  }
  function autoTranslate(root) {
    $$('[data-review-text]', root).forEach(function (el) {
      if (el.dataset.done) return;
      el.dataset.done = '1';
      if (!needsTranslation(el.textContent.trim())) return; // opinia już w języku strony – nic nie pokazujemy
      var card = el.closest('[data-review-id]');
      var btn = card && $('[data-translate]', card);
      translateReview(el).catch(function () {
        if (btn) btn.hidden = false; // nie udało się automatycznie – pokaż przycisk „Przetłumacz”
      });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-show-original]');
    if (!b) return;
    var note = b.closest('.translated-note');
    var el = note && note.previousElementSibling;
    if (!el || !el.dataset.original) return;
    var showingOriginal = el.textContent === el.dataset.original;
    el.textContent = showingOriginal ? el.dataset.translated : el.dataset.original;
    b.textContent = showingOriginal ? (S.showOriginal || '') : (S.translated || '');
  });

  function reviewHtml(r) {
    var done = false;
    try { done = !!localStorage.getItem('helpful_' + r._id); } catch (e) {}
    return '<article class="review" data-review-id="' + esc(r._id) + '">' +
      '<div class="review__head"><span class="review__author">' + esc(r.customer_name) + '</span>' + starsHtml(r.rating) + '</div>' +
      '<p class="review__text" data-review-text>' + esc(r.comment) + '</p>' +
      '<div class="review__foot"><span>' + esc(fmtDate(r.created_at)) + '</span>' +
      '<span class="review__actions">' +
      '<button type="button" class="chip-btn" data-helpful aria-pressed="' + done + '">' + thumbSvg + '<span>' + esc(S.helpful || 'OK') + '</span> <span data-helpful-count>' + (Number(r.helpful) || 0) + '</span></button>' +
      '<button type="button" class="chip-btn" data-translate hidden>' + translateSvg + '<span>' + esc(S.translate || 'Translate') + '</span></button>' +
      '</span></div></article>';
  }

  function renderSummary(reviews, stats) {
    var total = reviews.length;
    if (!total) return;
    var avg = reviews.reduce(function (s, r) { return s + (Number(r.rating) || 0); }, 0) / total;
    var avgText = fmtNumber(avg, 2);
    var shownTotal = (stats && stats.totalReviews) ? stats.totalReviews : total;
    var countText = '(' + shownTotal + ' ' + plural(shownTotal) + ')';
    $$('[data-rating-average]').forEach(function (el) { el.textContent = avgText; });
    $$('[data-rating-count]').forEach(function (el) { el.textContent = countText; });
    $$('[data-rating-line]').forEach(function (el) { el.hidden = false; });
    var summary = $('[data-reviews-summary]');
    if (summary) summary.hidden = false;

    var counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    var base = total;
    if (stats && stats.ratings && stats.totalReviews) {
      counts = stats.ratings; base = stats.totalReviews;
    } else {
      reviews.forEach(function (r) { var k = Math.round(Number(r.rating) || 0); if (counts[k] !== undefined) counts[k]++; });
    }
    for (var i = 1; i <= 5; i++) {
      var pct = base ? Math.round(((Number(counts[i]) || 0) / base) * 100) : 0;
      var bar = $('[data-bar="' + i + '"]');
      var label = $('[data-bar-label="' + i + '"]');
      if (bar) bar.style.width = pct + '%';
      if (label) label.textContent = pct + '%';
    }
  }

  function showMoreReviews() {
    var list = $('[data-review-list]');
    var more = $('[data-reviews-more]');
    if (!list) return;
    var next = reviewsState.all.slice(reviewsState.shown, reviewsState.shown + reviewsState.pageSize);
    list.insertAdjacentHTML('beforeend', next.map(reviewHtml).join(''));
    reviewsState.shown += next.length;
    autoTranslate(list);
    if (more) more.hidden = reviewsState.shown >= reviewsState.all.length;
  }

  function initReviews() {
    var cfg = OAK.reviews || {};
    var section = $('[data-reviews]');
    var ratingLine = $('[data-rating-line]');
    if ((!section && !ratingLine) || !cfg.api || !window.fetch) return;
    var api = cfg.api.replace(/\/$/, '');
    var status = $('[data-reviews-status]');

    Promise.all([
      fetch(api + '/reviews?product_id=' + encodeURIComponent(cfg.productId || '')).then(function (r) { if (!r.ok) throw r; return r.json(); }),
      fetch(api + '/review-stats').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
    ]).then(function (res) {
      var reviews = Array.isArray(res[0]) ? res[0] : [];
      reviewsState.all = reviews;
      renderSummary(reviews, res[1]);
      if (status) {
        if (reviews.length) status.hidden = true;
        else status.textContent = S.reviewsNone || '';
      }
      showMoreReviews();
    }).catch(function () {
      if (status) status.textContent = S.reviewsLoadError || '';
    });

    var more = $('[data-reviews-more]');
    if (more) more.addEventListener('click', showMoreReviews);

    var list = $('[data-review-list]');
    if (list) list.addEventListener('click', function (e) {
      var helpful = e.target.closest('[data-helpful]');
      var translate = e.target.closest('[data-translate]');
      var card = e.target.closest('[data-review-id]');
      if (!card) return;
      var id = card.getAttribute('data-review-id');

      if (helpful) {
        if (helpful.getAttribute('aria-pressed') === 'true') return;
        helpful.setAttribute('aria-pressed', 'true');
        fetch(api + '/reviews/helpful', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ review_id: id })
        }).then(function (r) { return r.json(); }).then(function (data) {
          if (data && data.success) {
            var c = $('[data-helpful-count]', helpful);
            if (c) c.textContent = (parseInt(c.textContent, 10) || 0) + 1;
            try { localStorage.setItem('helpful_' + id, '1'); } catch (err) {}
          } else { helpful.setAttribute('aria-pressed', 'false'); }
        }).catch(function () { helpful.setAttribute('aria-pressed', 'false'); });
      }

      if (translate) {
        var textEl = $('[data-review-text]', card);
        if (!textEl || translate.dataset.loading === '1') return;
        translate.dataset.loading = '1';
        translate.disabled = true;
        translateReview(textEl).then(function (ok) {
          if (!ok) translate.hidden = true;
        }).catch(function () {
          translate.disabled = false;
          translate.dataset.loading = '';
          var span = $('span', translate);
          if (span) span.textContent = S.translateError || '!';
        });
      }
    });

    initReviewForm(api, cfg);
  }

  function initReviewForm(api, cfg) {
    var form = $('[data-review-form]');
    if (!form) return;
    var errorEl = $('[data-review-error]', form);
    var okEl = $('[data-review-success]', form);
    var tpl = $('[data-review-messages]', form);
    function msg(key) {
      if (!tpl) return '';
      var el = tpl.content ? tpl.content.querySelector('[data-msg="' + key + '"]') : tpl.querySelector('[data-msg="' + key + '"]');
      return el ? el.textContent : '';
    }
    function fail(key, field) {
      errorEl.textContent = msg(key);
      errorEl.hidden = false;
      if (field) field.focus();
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorEl.hidden = true; okEl.hidden = true;
      var name = form.customer_name.value.trim();
      var orderField = form.order_number;
      var order = orderField.value.trim().replace(/\s+/g, '').toLowerCase();
      if (order && order.charAt(0) !== '#') order = '#' + order;
      var rating = (form.querySelector('input[name="rating"]:checked') || {}).value;
      var comment = form.comment.value.trim();
      if (order.indexOf('#oak100') !== 0) return fail('order', orderField);
      if (!rating) return fail('rating', form.querySelector('input[name="rating"]'));

      var btn = form.querySelector('button[type="submit"]');
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = S.sending || '…';
      fetch(api + '/reviews', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product_id: cfg.productId, customer_name: name, order_number: order, rating: rating, comment: comment })
      }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (saved) {
        okEl.hidden = false;
        form.reset();
        var review = (saved && saved._id) ? saved : { _id: 'new', customer_name: name, rating: Number(rating), comment: comment, created_at: new Date().toISOString(), helpful: 0 };
        var list = $('[data-review-list]');
        if (list) list.insertAdjacentHTML('afterbegin', reviewHtml(review));
      }).catch(function () {
        fail('send');
      }).then(function () {
        btn.disabled = false; btn.textContent = label;
      });
    });
  }

  /* ---------------- filmy ---------------- */
  function initVideos() {
    $$('[data-video]').forEach(function (box) {
      var btn = $('.video__button', box);
      if (!btn) return;
      btn.addEventListener('click', function () {
        var id = box.getAttribute('data-video');
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
        iframe.title = btn.getAttribute('aria-label') || 'YouTube';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        box.innerHTML = '';
        box.appendChild(iframe);
        iframe.focus();
      });
    });
  }

  /* ---------------- pasek „Zamów” na telefonie ---------------- */
  function initStickyBar() {
    var bar = $('[data-sticky-bar]');
    var product = $('#produkt');
    var hero = $('.hero');
    var footer = $('.site-footer');
    if (!bar || !product || !('IntersectionObserver' in window)) return;
    var vis = { product: false, hero: !!hero, footer: false };
    function apply() {
      var show = !vis.product && !vis.hero && !vis.footer && window.scrollY > 300;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      $$('a', bar).forEach(function (a) { if (show) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.target === product) vis.product = en.isIntersecting;
        if (en.target === hero) vis.hero = en.isIntersecting;
        if (en.target === footer) vis.footer = en.isIntersecting;
      });
      apply();
    }, { threshold: 0 });
    io.observe(product);
    if (hero) io.observe(hero);
    if (footer) io.observe(footer);
    window.addEventListener('scroll', apply, { passive: true });
  }

  /* ---------------- drobiazgi ---------------- */
  function initMenus() {
    // zamknij menu po kliknięciu w link lub poza menu, oraz klawiszem Esc
    $$('[data-close-menu]').forEach(function (a) {
      a.addEventListener('click', function () { var d = a.closest('details'); if (d) d.open = false; });
    });
    document.addEventListener('click', function (e) {
      $$('details.dropdown[open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('details.dropdown[open]').forEach(function (d) { d.open = false; var s = $('summary', d); if (s) s.focus(); });
    });
    // tylko jedno menu otwarte naraz
    $$('details.dropdown').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        $$('details.dropdown[open]').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  function initBackToTop() {
    var btn = $('[data-back-to-top]');
    if (!btn) return;
    function onScroll() { btn.classList.toggle('is-visible', window.scrollY > 1400); }
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); var m = $('#main'); if (m) m.focus({ preventScroll: true }); });
    onScroll();
  }

  function initReadingProgress() {
    var bar = $('[data-reading-progress]');
    if (!bar) return;
    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (h > 0 ? Math.min(100, (window.scrollY / h) * 100) : 0) + '%';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initCookiePrefs() {
    $$('[data-cookie-prefs]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          window.privacyBanner.showPreferences();
        } else {
          window.location.href = btn.getAttribute('data-fallback') || '/pages/terms#cookies';
        }
      });
    });
  }

  function initContactSuccess() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('success') !== 'true') return;
    var ok = $('[data-contact-success]');
    if (!ok) return;
    ok.hidden = false;
    var box = $('#kontakt');
    if (box) box.scrollIntoView({ block: 'center' });
  }


  /* ---------------- runda 3 ---------------- */
  function initThumbs() {
    $$('[data-thumbs]').forEach(function (wrap) {
      var box = wrap.closest('[data-buybox]') || document;
      var main = $('[data-buy-image]', box);
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-thumb]');
        if (!b || !main) return;
        main.src = b.dataset.image;
        if (b.dataset.srcset) main.srcset = b.dataset.srcset;
        $$('[data-thumb]', wrap).forEach(function (t) { t.classList.toggle('is-active', t === b); });
      });
    });
  }

  function initTextSize() {
    var root = document.documentElement;
    function apply(v) {
      root.classList.toggle('text-lg', v === '1');
      root.classList.toggle('text-xl', v === '2');
      $$('[data-text-size]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.textSize === v ? 'true' : 'false'); });
    }
    var cur = '0';
    try { cur = localStorage.getItem('oak-text-size') || '0'; } catch (e) {}
    apply(cur);
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-text-size]');
      if (!b) return;
      apply(b.dataset.textSize);
      try { localStorage.setItem('oak-text-size', b.dataset.textSize); } catch (err) {}
    });
  }

  function initExitHelp() {
    var dlg = $('[data-exit-help]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    if (!window.matchMedia('(min-width: 900px) and (pointer: fine)').matches) return;
    var shown = false;
    try { shown = sessionStorage.getItem('oak-exit-shown') === '1'; } catch (e) {}
    if (shown) return;
    var armed = false;
    setTimeout(function () { armed = true; }, 12000); // nie od razu po wejściu
    document.addEventListener('mouseout', function (e) {
      if (!armed || shown || e.relatedTarget || e.clientY > 8) return;
      if (document.querySelector('[data-buy-button][disabled]')) return; // już zamawia
      shown = true;
      try { sessionStorage.setItem('oak-exit-shown', '1'); } catch (err) {}
      dlg.showModal();
    });
    function close() { dlg.close(); }
    $$('[data-exit-close], [data-exit-back]', dlg).forEach(function (b) { b.addEventListener('click', close); });
    var back = $('[data-exit-back]', dlg);
    if (back) back.addEventListener('click', function () { var p = $('#produkt'); if (p) p.scrollIntoView(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
  }


  /* ---------------- tabela wyników badań ---------------- */
  function initStudy() {
    var panel = $('[data-study]');
    var toggle = $('[data-study-toggle]');
    if (!panel || !toggle || !window.fetch) return;
    toggle.hidden = false;
    var tpl = $('[data-study-strings]', panel);
    function str(k) { var el = tpl && tpl.content && tpl.content.querySelector('[data-k="' + k + '"]'); return el ? el.innerHTML : ''; }
    var loaded = false;
    function cellsHtml(cells) {
      var out = '<span class="cells" aria-hidden="true">';
      for (var i = 0; i < cells.length; i++) {
        var c = cells.charAt(i);
        out += '<span class="cell' + (c === 'g' ? ' cell--up' : c === 'r' ? ' cell--down' : '') + '"></span>';
      }
      return out + '</span>';
    }
    function load() {
      if (loaded) return;
      loaded = true;
      var groups = $('[data-study-groups]', panel);
      var lang = panel.getAttribute('data-lang') || 'pl';
      fetch(panel.getAttribute('data-src')).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (data) {
        var UP = 0, DOWN = 0, ALL = 0;
        groups.innerHTML = data.map(function (cat) {
          var up = 0, down = 0, all = 0;
          var rows = cat.items.map(function (it) {
            var g = (it.cells.match(/g/g) || []).length, r = (it.cells.match(/r/g) || []).length, n = it.cells.length;
            up += g; down += r; all += n;
            var label = g + ' ' + str('of') + ' ' + n + ' ' + str('meas') + ': ' + str('lup') + (r ? ', ' + r + ' ' + str('ldown') : '');
            return '<li class="study-row"><span class="study-row__name">' + esc(it.name[lang] || it.name.pl) + '</span>' +
              '<span class="study-row__data">' + cellsHtml(it.cells) + '<span class="study-row__count"><span class="visually-hidden">' + esc(label) + '</span><span aria-hidden="true"><strong>' + g + '</strong>/' + n + '</span></span></span></li>';
          }).join('');
          UP += up; DOWN += down; ALL += all;
          var pct = all ? Math.round(up / all * 100) : 0;
          return '<details class="study-group"><summary><span class="study-group__name">' + esc(cat.name[lang] || cat.name.pl) + '</span>' +
            '<span class="study-group__sum"><span class="study-bar" aria-hidden="true"><span style="width:' + pct + '%"></span></span>' +
            '<span class="study-group__pct">' + str('up') + ': <strong>' + up + '</strong> ' + str('of') + ' ' + all + '</span></span>' +
            '<span class="faq__icon" aria-hidden="true"></span></summary>' +
            (cat.cols !== 12 ? '<p class="study-group__note">' + str('men') + '</p>' : '') +
            '<ul class="study-rows">' + rows + '</ul></details>';
        }).join('');
        var total = $('[data-study-total]', panel);
        if (total) total.innerHTML = str('total').replace('%UP%', UP).replace('%ALL%', ALL).replace('%DOWN%', DOWN);
      }).catch(function () {
        groups.innerHTML = '<p class="message message--error">' + str('error') + '</p>';
        loaded = false;
      });
    }
    toggle.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      $('[data-study-label-open]', toggle).hidden = open;
      $('[data-study-label-close]', toggle).hidden = !open;
      if (open) { load(); panel.scrollIntoView({ block: 'start' }); }
    });
    var allBtn = $('[data-study-all]', panel);
    if (allBtn) allBtn.addEventListener('click', function () {
      var ds = $$('details.study-group', panel);
      var anyClosed = ds.some(function (d) { return !d.open; });
      ds.forEach(function (d) { d.open = anyClosed; });
      allBtn.textContent = anyClosed ? allBtn.dataset.closeLabel : allBtn.dataset.openLabel;
    });
  }

  /* ---------------- sklep DE: propozycja strony PL/EN ---------------- */
  function initLangSuggest() {
    var dlg = $('[data-lang-suggest]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    try { if (sessionStorage.getItem('oak-lang-suggest') === '1') return; } catch (e) {}
    var langs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || '']).map(function (l) { return String(l).toLowerCase(); });
    if (!langs[0] || langs.some(function (l) { return l.indexOf('de') === 0; })) return;
    var code = langs.some(function (l) { return l.indexOf('pl') === 0; }) ? 'pl' : 'en';
    var block = $('[data-lang-suggest-text="' + code + '"]', dlg);
    if (!block) return;
    block.hidden = false;
    dlg.setAttribute('aria-labelledby', 'lang-suggest-title-' + code);
    function remember() { try { sessionStorage.setItem('oak-lang-suggest', '1'); } catch (e) {} }
    function dismiss() { remember(); dlg.close(); }
    $$('[data-lang-suggest-close]', block).forEach(function (b) { b.addEventListener('click', dismiss); });
    $$('a', block).forEach(function (a) { a.addEventListener('click', remember); });
    dlg.addEventListener('cancel', remember);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dismiss(); });
    setTimeout(function () { if (!document.querySelector('dialog[open]')) dlg.showModal(); }, 700);
  }

  ready(function () {
    initQty(document);
    initBuyForms();
    initCart();
    initReviews();
    initVideos();
    initStickyBar();
    initMenus();
    initBackToTop();
    initReadingProgress();
    initCookiePrefs();
    initContactSuccess();
    initThumbs();
    initTextSize();
    initExitHelp();
    initStudy();
    initLangSuggest();
  });

  // po powrocie przyciskiem „Wstecz” z kasy odśwież licznik koszyka
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      refreshCartCount();
      $$('[data-buy-button]').forEach(function (b) { b.disabled = false; if (b.dataset.label) b.innerHTML = b.dataset.label; });
    }
  });

  window.OAKformatMoney = formatMoney;
})();
